import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { loginInterface } from 'app/Model/login.Interface';
import { LoginService } from 'app/services/login.service';
import { ToastrServiceLocal } from 'app/services/toast/toastr.service';
import { MensajesHttpService } from 'app/utils/mensajesHttp/mensajes-http.service';
import { environment } from 'environments/environment';
import { BehaviorSubject, EMPTY, Observable } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class LoginDsaFacadeService {

  private loading$ = new BehaviorSubject<any>({ loading: false, recurso: 'POST', message: 'Cargando Logueo', messages: [] });
  public responseLoading$: Observable<any> = this.loading$.asObservable();

  private error$ = new BehaviorSubject<any>({ hasError: false, recurso: 'POST', messageError: '', errors: [] });
  public responseError$: Observable<any> = this.error$.asObservable();

  constructor(private _loginService: LoginService, private _toast: ToastrServiceLocal,
    private _mensajeHttp: MensajesHttpService, private _router: Router) { }

  /**
   * @param tipo 1 = Empleado (flujo actual, con pre-chequeo en auth/v2/login),
   *             2 = Estudiante (spLoginAlumnoDSA ya valida todo internamente,
   *             se llama directo sin pre-chequeo).
   */
  loginDSA(params: any, tipo: number) {
    this.loading$.next({ loading: true, recurso: 'POST', message: 'Validando Usuario', messages: [] });
    this.error$.next({ hasError: false, recurso: 'POST', messageError: '', errors: [] });

    if (tipo === 2) {
      const request$ = this._loginService.logueoLc('login/loginAlumnoDSAComision', params).pipe(
        tap((result: loginInterface | any) => this.procesarLoginExitoso(result)),
        catchError((error: HttpErrorResponse) => this.manejarErrorLogin(error))
      );
      return request$.subscribe();
    }

    // Empleado: primero valida si existe el usuario en auth/v2/login
    const request$ = this._loginService.logueo('auth/v2/login', params).pipe(
      switchMap((validacionResult: any) => {
        const msj = validacionResult?.data?.table0?.[0]?.msj;
        if (msj === "ok") {
          // Si el usuario existe continua con el flujo de login
          return this._loginService.logueoLc('login/loginDSAComision', params).pipe(
            tap((result: loginInterface | any) => this.procesarLoginExitoso(result)),
            catchError((error: HttpErrorResponse) => this.manejarErrorLogin(error))
          );
        } else {
          // Si el usuario no existe, mostrar mensaje de error
          this._toast.mensajeError('Credenciales incorrectas. Por favor, verifica tu información.', 'Error');
          this.loading$.next({ loading: false, recurso: 'POST', message: 'Usuario no encontrado', messages: [] });
          return EMPTY;
        }
      }),
      catchError((error: HttpErrorResponse) => {
        this._mensajeHttp.mostrarErrorHttp(error, 'Error al validar el usuario', '');
        this.loading$.next({ loading: false, recurso: 'POST', message: 'Error en validación', messages: [] });
        return EMPTY;
      })
    );
    return request$.subscribe();
  }

  private procesarLoginExitoso(result: loginInterface | any): void {
    result?.user?.data?.Table0.forEach((item: any) => {
      if (item.hijos) { item.hijos = JSON.parse(item.hijos); }
    });
    localStorage.setItem("nombre", result?.user?.data?.Table1[0]?.nombre || '');
    const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(result?.user.data.Table0), result?.token).toString();
    localStorage.setItem("MFX_01", encryptedData);
    localStorage.setItem(environment.tokenLocal, result?.token);
    this.loading$.next({ loading: false, recurso: 'POST', message: 'Respuesta cargada', messages: [] });
    this._toast.mensajeSuccess('Bienvenido al portal DSA', '');
    this._router.navigateByUrl('/dashboard');
  }

  private manejarErrorLogin(error: HttpErrorResponse) {
    this._mensajeHttp.mostrarErrorHttp(error, 'Ocurrió un error al loguearse', '');
    this.loading$.next({ loading: false, recurso: 'POST', message: 'Error al loguearse', messages: [] });
    this.error$.next({ hasError: true, recurso: 'POST', messageError: this._mensajeHttp.mostrarErrorHttpString(error, 'Ocurrió un error al loguearse'), errors: [] });
    return EMPTY;
  }
}
